import { useState } from "react";
import { Mail, MessageCircle, Send } from "lucide-react";
import { toast } from "sonner";
import { CONTACT } from "@/data/site";
import Reveal from "@/components/Reveal";

const ContactSection = () => {
  const [form, setForm] = useState({ name: "", email: "", message: "" });

  const submit = (e) => {
    e.preventDefault();
    toast.success("تم استلام رسالتك!", {
      description: "سيتم ربط النموذج بقناة الاستلام النهائية قريباً.",
    });
    setForm({ name: "", email: "", message: "" });
  };

  return (
    <section id="contact" className="bg-navy-900 py-16 sm:py-24">
      <div className="container-x">
        <Reveal>
          <div className="grid gap-10 rounded-3xl border border-white/8 bg-navy-800/50 p-6 sm:p-10 lg:grid-cols-2 lg:gap-14">
            <div>
              <p className="mb-3 text-sm font-semibold text-gold">الدعوة الأخيرة</p>
              <h2 data-testid="contact-title" className="text-2xl font-bold leading-snug sm:text-3xl lg:text-4xl">
                {CONTACT.title}
              </h2>
              <p className="mt-4 leading-loose text-ink-soft sm:text-lg">{CONTACT.desc}</p>
              <div className="mt-8 space-y-4">
                <p className="flex min-h-[44px] items-center gap-3 text-sm text-ink-soft">
                  <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-teal-500/12 text-teal-400">
                    <Mail className="h-5 w-5" />
                  </span>
                  {CONTACT.email}
                </p>
                <p className="flex min-h-[44px] items-center gap-3 text-sm text-ink-soft">
                  <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-teal-500/12 text-teal-400">
                    <MessageCircle className="h-5 w-5" />
                  </span>
                  <span dir="ltr" className="font-en">{CONTACT.whatsapp}</span>
                </p>
              </div>
            </div>

            <form onSubmit={submit} data-testid="contact-form" className="space-y-4">
              <div>
                <label htmlFor="c-name" className="mb-1.5 block text-sm font-semibold">الاسم</label>
                <input
                  id="c-name"
                  data-testid="contact-name-input"
                  required
                  value={form.name}
                  onChange={(e) => setForm({ ...form, name: e.target.value })}
                  placeholder="اسمك الكريم"
                  className="h-12 w-full rounded-xl border border-white/10 bg-navy-900/70 px-4 text-base outline-none transition placeholder:text-ink-mute focus:border-teal-500 focus:ring-2 focus:ring-teal-500/20"
                />
              </div>
              <div>
                <label htmlFor="c-email" className="mb-1.5 block text-sm font-semibold">البريد الإلكتروني</label>
                <input
                  id="c-email"
                  type="email"
                  data-testid="contact-email-input"
                  required
                  dir="ltr"
                  value={form.email}
                  onChange={(e) => setForm({ ...form, email: e.target.value })}
                  placeholder="you@example.com"
                  className="h-12 w-full rounded-xl border border-white/10 bg-navy-900/70 px-4 text-left text-base outline-none transition placeholder:text-ink-mute focus:border-teal-500 focus:ring-2 focus:ring-teal-500/20"
                />
              </div>
              <div>
                <label htmlFor="c-msg" className="mb-1.5 block text-sm font-semibold">رسالتك أو هدفك</label>
                <textarea
                  id="c-msg"
                  data-testid="contact-message-input"
                  required
                  rows={4}
                  value={form.message}
                  onChange={(e) => setForm({ ...form, message: e.target.value })}
                  placeholder="مثال: أريد رفع درجة الـ IELTS الخاصة بي قبل التقديم للماجستير..."
                  className="w-full rounded-xl border border-white/10 bg-navy-900/70 p-4 text-base outline-none transition placeholder:text-ink-mute focus:border-teal-500 focus:ring-2 focus:ring-teal-500/20"
                />
              </div>
              <button
                type="submit"
                data-testid="contact-submit"
                className="flex min-h-[52px] w-full items-center justify-center gap-2 rounded-2xl bg-gold text-base font-bold text-navy-950 transition hover:bg-gold-strong"
              >
                <Send className="h-5 w-5" />
                أرسل الرسالة
              </button>
            </form>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default ContactSection;
